var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.content),expression:"content"}],ref:"text",class:_vm.$style.white,domProps:{"innerHTML":_vm._s(_vm.richContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }